module.exports = new __parcel__URL__("login.fa4f9103.html").toString();